module.exports = __webpack_public_path__ + "img/1.83c4e09.png";